<div class="modal-header" appCustomAutofocus>
    <h3>{{ headerText }}</h3>
</div>
<div class="modal-body">
    <p>{{ bodyText }}</p>
    <label for="numberInput">{{ inputLabelText }}</label>
    <input type="number" class="form-control" id="numberInput" [(ngModel)]="inputValue" />
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="saveAndClose()">{{ saveButtonText }}</button>
    <button type="button" class="btn btn-outline-dark" (click)="close()">{{ cancelButtonText }}</button>
</div>